export default class Currencies {
  static AUD = "AUD";

  static CAD = "CAD";

  static KWD = "KWD";

  static USD = "USD";
}
